import { ref } from 'vue'

/**
 * Blueprint theme. **Clinical 淺色為預設** —— 首次進站不跟 OS 走，一律淺色
 * （冷白 + 臨床 teal）。使用者 toggle 後切到深藍 Blueprint 並記住選擇。Applies
 * `data-theme` on <html> (drives styles/tokens.css) 與 `dark` class（drives
 * Element Plus 的 dark css-vars）。
 */
type Stored = 'light' | 'dark'
const KEY = 'g365_theme_v1'
const DEFAULT: Stored = 'light' // Clinical 淺色是預設外觀

const stored = (): Stored | null => {
  const v = localStorage.getItem(KEY)
  return v === 'light' || v === 'dark' ? v : null
}

const isDark = ref((stored() ?? DEFAULT) === 'dark')

function apply(): void {
  const root = document.documentElement
  const theme: Stored = isDark.value ? 'dark' : 'light'
  root.setAttribute('data-theme', theme) // 一律 pin，預設深藍
  root.classList.toggle('dark', isDark.value)
}

export function initTheme(): void {
  apply()
}

export function useTheme() {
  function toggle(): void {
    isDark.value = !isDark.value
    localStorage.setItem(KEY, isDark.value ? 'dark' : 'light')
    apply()
  }
  return { isDark, toggle }
}
